import React from 'react';
import { useTranslations } from '../../localization/useTranslations';

const EmptyWrapper = () => {
  const translations = useTranslations();

  return (
    <div className="my-subscriptions__empty-wrapper">
      <div className="my-subscriptions__empty-container empty-state">
        <p className="empty-message">{translations?.emptyStates?.noActiveSubscriptions || 'No active subscriptions'}</p>
      </div>
    </div>
  );
};

export default EmptyWrapper;
